import { render, staticRenderFns } from "./PublicMenu.vue?vue&type=template&id=0512c9b2&scoped=true"
import script from "./PublicMenu.vue?vue&type=script&lang=js"
export * from "./PublicMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0512c9b2",
  null
  
)

export default component.exports